import React, { useState, useMemo } from 'react';

import { CreateSecondaryToken, GetJustWhereUsers, CreateConfirmation, ListConfirmations } from "../utilities/calls";
import { sanitizeEmail } from "../utilities/functions";
import ActionMessage from "./ActionMessageModal";
const ConfirmationComponent = ({ issuedAllowed = false, entityJRN, fromJRN, toJRN, token, refresh }) => {
  const [closed, setClosed] = useState(true);
  const [modal, setModal] = useState({ show: false, message: "" });
  const [alreadyConfirmed, setAlreadyConfirmed] = useState(false);
  const [suggestedEmail, setSuggestedEmail] = useState('')
  const [inputEmail, setInputEmail] = useState('')

  const handleConfirm = () => {
    let tojrn = toJRN ? toJRN : fromJRN
    let type = "Checked";
    
    if (alreadyConfirmed) {
    	   return
    }
        
    let confm = {
        "fromJRN": fromJRN,
        "toJRN": tojrn,
        "type": type,
        "EntityJRN": entityJRN,
        "tags": {},
        "optionalSharedToken": token,
	};
    
    CreateConfirmation(confm).then(resp => {
        setModal({ show: true, message: "Confirmation was created successfully!" })
        setClosed(true)
        setAlreadyConfirmed(true)
        if (refresh) {
        	  refresh()
        }
    }).catch(err => setModal({ show: true, message: `Confirmation creation Failed! ${err} `  }));
    
  };

  const handleConfirmIssue = () => {
    
    if (suggestedEmail === '') {
        setModal({ show: true, message: "Can not Issue Confirmation as user email is not a valid User!"  });
        return
    }
    
    let tojrn = `jrn:user:${suggestedEmail}`
    let type = "Issued";
    
    if (alreadyConfirmed) {
    	   return
    }
    
    let spid = getID(fromJRN)
    let benid = tojrn
    let confm = {
        "fromJRN": fromJRN,
        "toJRN": benid,
        "type": type,
        "EntityJRN": entityJRN,
        "tags": {},
        "optionalSharedToken": token,
    };

    CreateConfirmation(confm).then(resp => {
        setModal({ show: true, message: "Confirmation was created successfully!" })
        setClosed(true)
        setAlreadyConfirmed(true)
        if (refresh) {
          refresh()
        }
    }).catch(err => setModal({ show: true, message: `Confirmation Failed! ${err} `  }));
    
  };

  const handleCancel = () => {
	setModal({ show: false, message: "" })
    setClosed(true)
  };

  const getTypeLabel = (jrn = "") => {
	  if (jrn.startsWith('jrn:address:')) return 'Address';
	  if (jrn.startsWith('jrn:securedcontent:')) return 'Secured Content';
	  if (jrn.startsWith('jrn:stream:')) return 'Document';
	  return 'Unknown';
  };

  const checkConfirmed = () => {
	  entityJRN && ListConfirmations("", fromJRN, "", entityJRN)
      .then((response) => {
        if (Array.isArray(response) && response.length > 0) {
	      setAlreadyConfirmed(true)
	    } else {
		  setAlreadyConfirmed(false)
	    }
      })
      .catch((error) => {
        setModal({ show: true, message: `Can not get Confirmations! ${error} `  })
      });
  };

  const checkEmail = (email) => {
        let val = email.target.value
        setInputEmail(val)
        GetJustWhereUsers([val]).then((resp) => {
            if (resp.validUserIds?.length === 0) {
                const updatedUserEmail = sanitizeEmail(val)
                GetJustWhereUsers([updatedUserEmail]).then((resp) => {
                    if (resp.validUserIds?.length > 0) {
                        setSuggestedEmail(resp.validUserIds[0])
                    } else {
                        setSuggestedEmail('')
                    }
                }).catch((err) => {
                    console.log(err);
                    setModal({ show: true, message: `Can not confirm JustWhere User! ${err} `  })
                })
            } else {
                setSuggestedEmail(val)
            }
        }).catch((err) => { console.log(err);
            setModal({ show: true, message: `Can not get Confirmations! ${err} `  })
         })
    }

  useMemo(() => {
	entityJRN && checkConfirmed()
  },[]);

  const getID = (jrn = "") => {
      const parts = jrn.split(':', 3);
      return parts.length === 3 ? parts[2] : "";
  };

  return (
	<>
	{ closed && entityJRN ? (<button 
	          onClick={() => {alreadyConfirmed ? setClosed(true) : setClosed(false)}}
	          className="px-6 py-2 bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded-md transition-colors"
	        >
	          {alreadyConfirmed ? "It is Confirmed by Us!" : "We can Confirm it!"}
	   </button>): <></>}
	   <>
		{ !closed && entityJRN ? (
		    <div className="p-6 bg-gray-900 text-white border border-gray-700 rounded-lg shadow-xl max-w-full">
		      <p className="mb-6 text-lg font-medium leading-relaxed">
		        Please Confirm the validity of {getTypeLabel(entityJRN)} shared with you with ID : {getID(entityJRN)}<br />
		        Owner can share your confirmation with others! If you Confirm and Release, Document will be handed over to the User with below Email!
		      </p>
		      {
                    (issuedAllowed) ? (
                      <div className="py-3 items-center">
                        <button
            		          onClick={handleConfirmIssue}
            		          className="px-2 py-1 bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded-md transition-colors"
            		        >
            		          Confirm AND Release to
		                </button>
                        <input name="email"
                                type="text"
                                value={inputEmail}
                                onChange={checkEmail}
                                onClick={checkEmail}
                                placeholder="Enter Email"
                                className="mt-1 px-2 col-span-2 form-input py-1"
                            />
                      </div>
                    ) : <></>
                }
		      <div className="flex gap-4">
		        <button 
		          onClick={handleConfirm}
		          className="px-6 py-1 bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded-md transition-colors"
		        >
		          Confirm Only
		        </button>
                
		        
		        <button 
		          onClick={handleCancel}
		          className="px-6 py-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md transition-colors"
		        >
		          Cancel
		        </button>
		      </div>
		    </div> ) : <></>
		 }
		</>
		<>
		 {modal.show && (
          <ActionMessage isOpen={modal.show} onClose={()=> {setModal({ show: false })}} message={modal.message} />
		  )
          }
        </>
	</>
  );
};

export default ConfirmationComponent;
